export default "__VITE_ASSET__PfPlHSnP__"